const utils = require('./utils');

let viewportMetaTag = null;

if (utils.mobileOSDetection() === 'windows-phone') {

  // Fix for Windows Phone scaling issue
  viewportMetaTag = document.querySelector('[name="viewport"]');
  if (viewportMetaTag) {
    viewportMetaTag.content = 'width=device-width, initial-scale=1, user-scalable=no';
  }

}
